import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  '.title': {
    marginTop: constants.offset.xlarge,
    marginBottom: constants.offset.xlarge,
    whiteSpace: 'pre-line',
    fontSize: rem(constants.fontSize.h1),
    fontWeight: 200,
    color: theme.success,
  },

  '.subtitle': {
    marginTop: 0,
    marginBottom: constants.offset.medium,
    whiteSpace: 'pre-line',
    fontSize: rem(constants.fontSize.medium),
    fontWeight: 700,
    color: theme.textPrimary,
  },

  '.description': {
    marginBottom: constants.offset.xlarge,
    whiteSpace: 'pre-line',
    lineHeight: 1.2,
    color: theme.textPrimary,

    '&.last': {
      marginBottom: constants.offset.xsmall,
    },
  },

  '.help-list': {
    listStyle: 'none',
    paddingLeft: constants.offset.medium,

    'li:before': {
      content: '""',
      backgroundColor: theme.primary,
      marginLeft: -constants.offset.medium,
      marginTop: constants.offset.xsmall,
      width: 8,
      height: 8,
      borderRadius: 100,
      position: 'absolute',
    },
  },

  '.link': {
    marginLeft: constants.offset.xsmall,
  },

  '.button': {
    marginBottom: constants.offset.xlarge,
  },

  '.floating-image': {
    float: 'right',
    marginTop: -constants.offset.medium,
    marginRight: -constants.offset.xxlarge,
    paddingLeft: constants.offset.medium,
    paddingBottom: constants.offset.medium,
    maxWidth: 150,
  },
};
